import { useSelector } from 'react-redux';

const Feature = ({ name, children }) => {
  const { Features_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};
  const feature = Features_Setting?.find((feature) => feature.Name === name);

  if (feature && feature.Status) {
    return children;
  } else {
    return null;
  }
};

export default Feature;
